(function() { window.GUID_c6607e21_2037_4f80_b974_ccb0cc3b7c3f = { getGuid: function() { return "c6607e21-2037-4f80-b974-ccb0cc3b7c3f"; } }; })();
var CS;
(function (CS) {
    let CSS;
    (function (CSS) {
        let currentStylesLoadedCount = null;
        let stylesCountToTest = null;
        function ResetFileLoadedCount() {
            currentStylesLoadedCount = null;
            stylesCountToTest = null;
        }
        CSS.ResetFileLoadedCount = ResetFileLoadedCount;
        function FileLoaded() {
            if (!currentStylesLoadedCount) {
                currentStylesLoadedCount = 0;
            }
            currentStylesLoadedCount += 1;
            TryAllStylesLoaded();
        }
        CSS.FileLoaded = FileLoaded;
        function TryAllStylesLoaded() {
            if (stylesCountToTest && stylesCountToTest == currentStylesLoadedCount) {
                if (CS.Views.ViewBase.CurrentView) {
                    CS.Views.ViewBase.CurrentView.OnAllCssFilesLoaded();
                }
            }
        }
        CSS.TryAllStylesLoaded = TryAllStylesLoaded;
        function DetermineCssFilesCountToTest() {
            stylesCountToTest = CS.DOM.$sectionMaster.find('link').length;
            TryAllStylesLoaded();
        }
        CSS.DetermineCssFilesCountToTest = DetermineCssFilesCountToTest;
    })(CSS = CS.CSS || (CS.CSS = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-css-files-loaded-helper.js.map
